import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { WrapperComponent } from './../wrapper/wrapper.component';

@Component({
  selector: 'qaroni-layout',
  standalone: true,
  imports: [RouterOutlet, WrapperComponent],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LayoutComponent {}
